"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSyncConflictViewModel = exports.summarizeSyncConflictChanges = exports.normalizeServerRow = exports.extractQueuedClientPatch = exports.extractQueuedRowId = exports.getSyncFailureMeta = exports.isPilotNotesSyncConflict = exports.PilotNotesSyncConflictError = void 0;
var resultRowDraftStorage_1 = require("./resultRowDraftStorage");
var PilotNotesSyncConflictError = /** @class */ (function (_super) {
    __extends(PilotNotesSyncConflictError, _super);
    function PilotNotesSyncConflictError(result) {
        var _this = _super.call(this, result.error || 'Server row changed since your offline edit') || this;
        _this.name = 'PilotNotesSyncConflictError';
        _this.result = result;
        return _this;
    }
    return PilotNotesSyncConflictError;
}(Error));
exports.PilotNotesSyncConflictError = PilotNotesSyncConflictError;
var SYNC_DIFF_FIELDS = [
    'pnBody',
    'pnCustomTimeUTC',
    'pnCompletedUTC',
    'pnValue',
    'pnValueUnit',
    'pnItemCode',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnInvoiceNote',
    'pnAssetTag',
    'pnAssetTagAux',
];
function isPilotNotesSyncConflict(error) {
    var _a;
    var candidate = error;
    return ((_a = candidate === null || candidate === void 0 ? void 0 : candidate.result) === null || _a === void 0 ? void 0 : _a.status) === 'conflict';
}
exports.isPilotNotesSyncConflict = isPilotNotesSyncConflict;
function getSyncFailureMeta(error) {
    var _a;
    if (isPilotNotesSyncConflict(error)) {
        return {
            message: error.message,
            isConflict: true,
            serverRow: (_a = error.result.server_row) !== null && _a !== void 0 ? _a : null,
            result: error.result,
        };
    }
    return {
        message: error instanceof Error ? error.message : String(error),
        isConflict: false,
        serverRow: null,
        result: null,
    };
}
exports.getSyncFailureMeta = getSyncFailureMeta;
function extractQueuedRowId(payload) {
    var _a, _b, _c;
    if (!payload || typeof payload !== 'object') {
        return null;
    }
    var record = payload;
    var candidates = [
        (_a = record.edit) === null || _a === void 0 ? void 0 : _a.ID,
        (_b = record.row) === null || _b === void 0 ? void 0 : _b.ID,
        (_c = record.rowArray) === null || _c === void 0 ? void 0 : _c.ID,
        record.ID,
    ];
    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
        var candidate = candidates_1[_i];
        var parsed = Number(candidate);
        if (Number.isFinite(parsed) && parsed > 0) {
            return parsed;
        }
    }
    return null;
}
exports.extractQueuedRowId = extractQueuedRowId;
function extractQueuedClientPatch(payload) {
    if (!payload || typeof payload !== 'object') {
        return {};
    }
    var record = payload;
    var patch = {};
    for (var _i = 0, _a = ['edit', 'row', 'rowArray']; _i < _a.length; _i++) {
        var key = _a[_i];
        var source = record[key];
        if (source && typeof source === 'object') {
            Object.assign(patch, source);
        }
    }
    return patch;
}
exports.extractQueuedClientPatch = extractQueuedClientPatch;
function normalizeServerRow(serverRow) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!serverRow) {
        return {};
    }
    return __assign(__assign({}, serverRow), { pnBody: (_a = serverRow.pnBody) !== null && _a !== void 0 ? _a : serverRow.body, pnCustomTimeUTC: (_b = serverRow.pnCustomTimeUTC) !== null && _b !== void 0 ? _b : serverRow.start_time, pnCompletedUTC: (_c = serverRow.pnCompletedUTC) !== null && _c !== void 0 ? _c : serverRow.end_time, pnValue: (_d = serverRow.pnValue) !== null && _d !== void 0 ? _d : serverRow.value, pnValueUnit: (_e = serverRow.pnValueUnit) !== null && _e !== void 0 ? _e : serverRow.value_unit, pnItemCode: (_f = serverRow.pnItemCode) !== null && _f !== void 0 ? _f : serverRow.item_code, pnTaskGroup: (_g = serverRow.pnTaskGroup) !== null && _g !== void 0 ? _g : serverRow.task_group, pnTopicGroup: (_h = serverRow.pnTopicGroup) !== null && _h !== void 0 ? _h : serverRow.topic_group, pnTopicDetail: (_j = serverRow.pnTopicDetail) !== null && _j !== void 0 ? _j : serverRow.topic_detail, pnInvoiceNote: (_k = serverRow.pnInvoiceNote) !== null && _k !== void 0 ? _k : serverRow.invoice_note, pnAssetTag: (_l = serverRow.pnAssetTag) !== null && _l !== void 0 ? _l : serverRow.asset_tag, pnAssetTagAux: (_m = serverRow.pnAssetTagAux) !== null && _m !== void 0 ? _m : serverRow.asset_tag_aux, pnUpdated: (_o = serverRow.pnUpdated) !== null && _o !== void 0 ? _o : serverRow.updated });
}
exports.normalizeServerRow = normalizeServerRow;
function formatDisplayValue(field, value) {
    if (value === undefined || value === null || value === '') {
        return '(empty)';
    }
    if (field === 'pnBody') {
        var text = String(value);
        return text.length > 80 ? "".concat(text.slice(0, 80), "\u2026") : text;
    }
    if (field === 'pnCustomTimeUTC' || field === 'pnCompletedUTC') {
        var date = value instanceof Date ? value : new Date(String(value));
        return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
    }
    return String(value);
}
function summarizeSyncConflictChanges(clientPatch, serverRow) {
    var normalizedServer = normalizeServerRow(serverRow);
    var changes = [];
    SYNC_DIFF_FIELDS.forEach(function (field) {
        if (!(field in clientPatch)) {
            return;
        }
        var clientValue = clientPatch[field];
        var serverValue = normalizedServer[field];
        if (JSON.stringify(clientValue !== null && clientValue !== void 0 ? clientValue : null) === JSON.stringify(serverValue !== null && serverValue !== void 0 ? serverValue : null)) {
            return;
        }
        changes.push({
            field: field,
            label: resultRowDraftStorage_1.FIELD_LABELS[field] || field,
            clientDisplay: formatDisplayValue(field, clientValue),
            serverDisplay: formatDisplayValue(field, serverValue),
        });
    });
    return changes;
}
exports.summarizeSyncConflictChanges = summarizeSyncConflictChanges;
function buildSyncConflictViewModel(entry) {
    var _a, _b;
    var clientPatch = extractQueuedClientPatch(entry.payload);
    var rowId = extractQueuedRowId(entry.payload);
    var changes = summarizeSyncConflictChanges(clientPatch, entry.serverRow);
    var summary = changes.length > 0
        ? changes.map(function (change) { return "".concat(change.label, ": yours \"").concat(change.clientDisplay, "\" vs server \"").concat(change.serverDisplay, "\""); }).join('; ')
        : entry.lastError || 'Server row changed since your offline edit';
    return {
        id: entry.id,
        rowId: rowId,
        kind: entry.kind,
        createdAt: entry.createdAt,
        lastError: (_a = entry.lastError) !== null && _a !== void 0 ? _a : null,
        summary: summary,
        changes: changes,
        serverRow: (_b = entry.serverRow) !== null && _b !== void 0 ? _b : null,
        clientPatch: clientPatch,
    };
}
exports.buildSyncConflictViewModel = buildSyncConflictViewModel;
